import Vue from 'vue'
import MetaInfo from 'vue-meta-info'
import path from './basePath.js'
import util from './util.js'

import '../css/reset.css'

Vue.prototype.PATHS = path;
Vue.prototype.UTILS = util;
Vue.use(MetaInfo);
